export const environment = {
  envName: 'dev',
  hmr: false,
  production: false,
  apiURL: 'https://back.devarea.app/mBase',
  serviceWorker: true,
  oauth: {
    host: 'back.devarea.app',
    https: true,
    client_id: 'mbase',
    client_secret: 'mbase'
  }
};
